import { Controller } from "@hotwired/stimulus"

// data-controller="lessons--materials"
export default class extends Controller {
  connect() {
    this.element.addEventListener("lesson:loaded", this.update.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("lesson:loaded", this.update.bind(this))
  }

  update(event) {
    const { description, digital_notebooks = [], pdf_completos = [], pdf_resumidos = [], mapa_mentais = [], audios = [] } = event.detail

    this.renderSection("#tab-digital-notebook", digital_notebooks, this.buildMaterialCard)
    this.renderSection("#tab-pdf-completo", pdf_completos, this.buildMaterialCard)
    this.renderSection("#tab-pdf-resumido", pdf_resumidos, this.buildMaterialCard)
    this.renderSection("#tab-mapa-mental", mapa_mentais, this.buildMaterialCard)
    this.renderSection("#tab-audio", audios, this.buildAudioCard)
    this.renderDescription(description)
  }

  renderDescription(description) {
    const container = document.querySelector("#tab-observation .lesson-observation__body")
    if (!container) return
    container.innerHTML = `
      <div class="lesson-observation__content">
        ${description}
      </div>`
  }

  renderSection(selector, items = [], builder) {
    const pane = document.querySelector(selector)
    if (!pane) return

    const grid = pane.querySelector("[data-materials-target='grid']")
    if (!grid) return

    grid.innerHTML = ""

    if (!items.length) {
      pane.classList.add("is-empty")
      return
    }

    pane.classList.remove("is-empty")
    items.forEach((item, index) => grid.insertAdjacentHTML("beforeend", builder.call(this, item, index)))
  }

  buildAudioCard(item) {
    const title = item.name.split(".").shift().replace(/[-_]/g, " ")

    return `
      <div class="digital-notebook__card">
        <div class="digital-notebook__badge">
          <i class="fa fa-file-audio-o" aria-hidden="true"></i>
          <span>${item.label}</span>
        </div>
        <h6 class="digital-notebook__title">
          ${title}
        </h6>
        <div class="digital-notebook__meta">
          <span><i class="fa fa-clock-o" aria-hidden="true"></i> Atualizado em ${item.updated_at}</span>
          <span><i class="fa fa-database" aria-hidden="true"></i> ${item.size}</span>
        </div>
        <div class="digital-notebook__player">
          <audio controls preload="metadata" src="${item.file}">
            Seu navegador não suporta reprodução de áudio.
          </audio>
        </div>
        <div class="digital-notebook__actions">
          <button class="btn btn-primary btn-sm" type="button" onclick="window.open('${item.file}', '_blank')">
            <i class="fa fa-download" aria-hidden="true"></i>
            Baixar
          </button>
        </div>
      </div>
    `
  }

  buildMaterialCard(item, index) {
    return `
      <div class="digital-notebook__card">
        <div class="digital-notebook__badge">
          <i class="fa fa-file-text-o" aria-hidden="true"></i>
          <span>${item.label}</span>
        </div>
        <h6 class="digital-notebook__title">
          ${item.name}
        </h6>
        <div class="digital-notebook__meta">
          <span><i class="fa fa-clock-o" aria-hidden="true"></i> Atualizado em ${item.updated_at}</span>
          <span><i class="fa fa-database" aria-hidden="true"></i> ${item.size}</span>
        </div>
        <p class="digital-notebook__description">
          ${item.description || ""}
        </p>
        <div class="digital-notebook__actions">
          <button class="btn btn-outline-light btn-sm" type="button" onclick="window.open('${item.file}', '_blank')">
            <i class="fa fa-external-link" aria-hidden="true"></i>
            Visualizar
          </button>
          <button class="btn btn-primary btn-sm" type="button" onclick="window.open('${item.file}', '_blank')">
            <i class="fa fa-download" aria-hidden="true"></i>
            Baixar
          </button>
        </div>
      </div>
    `
  }

  renderObservation(text) {
    const container = document.querySelector("#tab-observation .lesson-observation__body")
    if (!container) return
    container.innerHTML = text || `
      <div class="lesson-observation__empty">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        <p>Nenhuma observação cadastrada para esta aula.</p>
      </div>
    `
  }

  async download(event) {
    const button = event.currentTarget
    const nowLesson = document.querySelector("#now-lesson")
    const lessonId = nowLesson.dataset.lesson.split("-")[1]

    const response = await fetch(`/lessons/${lessonId}/download_material_lesson?media_id=${button.dataset.id}`, {
      method: "GET",
      headers: { "Content-Type": "application/json; charset=UTF-8" },
    })

    if (!response.ok) {
      alert("Não foi possível abrir o material.")
      return
    }

    window.open(button.dataset.file, "_blank")
  }
}